import * as i0 from '@angular/core';
import * as i1 from './root.module';
import * as i2 from '@fs-tw/theme-alain/layout';
import * as i3 from './components/validation-error-component/validation-error.component';
import * as i4 from './base-root.module';
export const RootModuleNgFactory:i0.NgModuleFactory<i1.RootModule> = (null as any);
var _decl0_0:i2.LayoutBasicComponent = (<any>(null as any));
var _decl0_1:i2.LayoutBlankComponent = (<any>(null as any));
var _decl0_2:i2.LayoutPassportComponent = (<any>(null as any));
var _decl0_3:i3.ValidationErrorComponent = (<any>(null as any));
var _decl0_4:i2.LayoutModule = (<any>(null as any));
var _decl0_6:i4.BaseRootModule = (<any>(null as any));
var _decl0_7:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_8:i0.ElementRef<any> = (<any>(null as any));
